import { render, staticRenderFns } from "./reisetermin-card-vorgaenge-teilnehmer.vue?vue&type=template&id=3c4bea6a&scoped=true"
import script from "./reisetermin-card-vorgaenge-teilnehmer.vue?vue&type=script&lang=js"
export * from "./reisetermin-card-vorgaenge-teilnehmer.vue?vue&type=script&lang=js"
import style0 from "./reisetermin-card-vorgaenge-teilnehmer.vue?vue&type=style&index=0&id=3c4bea6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4bea6a",
  null
  
)

export default component.exports